module.exports = __webpack_public_path__ + "img/nookpoints.f140ef50.svg";